import { Box } from "@mui/material";

import Heading from "../theme/Heading";

const AcceptedCount = ({
  count,
  global,
}: {
  count: number;
  global?: boolean;
}) => {
  if (count <= 1) {
    return null;
  }

  return (
    <Box sx={{ display: "flex", justifyContent: "start" }}>
      <Box
        sx={{
          display: "inline-flex",
          gap: "1em",
          backgroundColor: "primary.main",
          color: "white",
          padding: "1em",
          alignItems: "center",
          borderRadius: "10px",
        }}
      >
        <Heading
          component="div"
          sx={{ fontSize: "50px!important" }}
          variant="h1"
        >
          {count}
        </Heading>
        <Box>
          {global
            ? "demonstranten zijn al gekoppeld aan een sponsor."
            : "deelnemers aan deze demonstratie krijgen hun reiskosten al vergoed."}
        </Box>
      </Box>
    </Box>
  );
};

export default AcceptedCount;
